import styled from 'styled-components'

export const Colors = {
  White: '#FFFFFF',
  Black: '#000000',
  Violet: '#BD5DE2',
  VioletDark: '#8C21BA',
  VioletLight: '#D37EF4',
  VioletSecondary: '#FAEDFF',
  VioletSecondaryDark: '#F6DBFF',
  VioletSecondaryLight: '#FDF7FF',
  BlueLink: '#4360DF',
  BlueBar: '#D6E0FF',
  Orange: '#FFE6CF',
  GrayOverlay: '#E5E5E5',
  GrayDisabledDark: '#888888',
  GrayDisabledLight: '#EAEBED',
  GreyText: '#939BA1',
  GreyTextDisabled: '#B1B1B1',
  GrayLight: '#FBFCFE',
  GrayBorder: '#EEF2F5',
  Green: '#4EBC60',
  ShadowCard: '0px 2px 12px rgba(0, 0, 0, 0.15)',
  Red: '#D0342C',
}

export const Font = 'Inter, sans-serif'

export const ColumnFlexDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const WrapperBottom = styled.div`
  margin-bottom: 24px;
`

export const WrapperBottomMid = styled.div`
  margin-bottom: 32px;
  width: 100%;
`

export const WrapperTopSmall = styled.div`
  margin-top: 16px;
`
export const WrapperTop = styled.div`
  margin-top: 32px;
`
export const MobileWrap = styled.div`
  padding: 0 0 16px;
`

export const MobileTop = styled.div`
  padding: 0 16px;
`

export const MobileBlock = styled.div`
  padding: 16px;
  width: 100%;
`
export const MobileHeading = styled.h2`
  font-weight: bold;
  font-size: 17px;
  line-height: 24px;
`
